import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { C, T } from './leadOverviewCardTokens';
import { OverviewCardTitleWithIcon } from './overviewCardPrimitives';
import { stripHtmlToPlain } from './overviewFormatUtils';

function LatestNotePeekSection({ notes, onAddNote, readOnly }) {
  const first = Array.isArray(notes) && notes.length ? notes[0] : null;
  const plain = first ? stripHtmlToPlain(first.text) : '';
  const showTip = Boolean(plain);
  const bodyTypography = (
    <Typography
      sx={{
        ...T.snapshotBody,
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        wordBreak: 'break-word',
        cursor: showTip ? 'help' : 'default',
      }}
    >
      {plain || (first ? '—' : '')}
    </Typography>
  );
  return (
    <Box sx={{ flexShrink: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1.25 }}>
        <OverviewCardTitleWithIcon icon="📝" iconBg="#FEF3C7" title="Latest note" boxSize={26} fontSize="11px" sx={{ flex: 1, minWidth: 0 }} />
        {onAddNote && !readOnly ? (
          <Typography
            component="button"
            type="button"
            onClick={onAddNote}
            sx={{
              fontSize: '11px',
              fontWeight: 700,
              color: C.teal,
              border: 'none',
              bgcolor: 'transparent',
              cursor: 'pointer',
              fontFamily: 'inherit',
              p: 0,
              flexShrink: 0,
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            + Add Note
          </Typography>
        ) : null}
      </Box>
      {!first ? (
        <Typography sx={{ ...T.snapshotBody, fontStyle: 'italic', color: C.slate4 }}>No notes added yet</Typography>
      ) : (
        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
          <Box
            sx={{
              width: 3,
              borderRadius: '2px',
              bgcolor: '#F59E0B',
              flexShrink: 0,
              alignSelf: 'stretch',
              minHeight: 40,
            }}
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '4px' }}>
              <Box
                sx={{
                  width: 22,
                  height: 22,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg,#E24B4A,#C93D3C)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '9px',
                  fontWeight: 700,
                  color: '#fff',
                  flexShrink: 0,
                }}
              >
                {first.initials}
              </Box>
              <Typography sx={{ ...T.snapshotTitle }}>{first.author}</Typography>
            </Box>
            <Typography sx={{ ...T.snapshotMeta, mb: '6px' }}>{first.time}</Typography>
            {showTip ? (
              <Tooltip title={plain} placement="top" enterDelay={400}>
                {bodyTypography}
              </Tooltip>
            ) : (
              bodyTypography
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default function LeadRecentNotes({ notes, onAddNote, readOnly }) {
  return (
    <Box
      sx={{
        bgcolor: C.white,
        border: `1px solid ${C.border}`,
        borderRadius: '14px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
        p: '18px',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
      }}
    >
      <LatestNotePeekSection notes={notes} onAddNote={onAddNote} readOnly={readOnly} />
    </Box>
  );
}
